import React from "react";
import Checkbox from "react-three-state-checkbox";
import { FormGroup, Label } from "reactstrap";

interface TriCheckboxProps {
  label: string;
  state: boolean | null | undefined;
  changeState: (newState: boolean | null | undefined) => void;
  disabled?: boolean;
}

/**
 * Three-state filter checkbox: include (checked), exclude (unchecked), or no
 * filter (indeterminate).
 *
 * The indeterminate dash is the universal "nothing applied" affordance, so it
 * represents *no filter*. It previously represented "exclude", which made an
 * active exclusion indistinguishable from an unfiltered column.
 *
 * The label wraps the control so clicking the text toggles it; it used to be a
 * sibling, leaving only the ~16px box clickable.
 */
const TriCheckbox: React.FC<TriCheckboxProps> = ({ label, state, changeState, disabled }) => (
  <FormGroup className="mb-0 d-flex align-items-center justify-content-end">
    <Label
      className="form-control-label mb-0 d-flex align-items-center"
      style={{ gap: ".5rem", cursor: disabled ? "default" : "pointer" }}
      check
    >
      <span>{label}</span>
      <Checkbox
        checked={state === true}
        indeterminate={state === null || state === undefined}
        onChange={() => changeState(state === true ? false : state === false ? undefined : true)}
        disabled={disabled}
      />
    </Label>
  </FormGroup>
);

export default TriCheckbox;
